import React, { Fragment, useEffect, useState } from 'react';
import classnames from 'classnames';
import { isEmpty } from 'lodash/fp';
import IconCaret from '../../files/caret.svg';
import IconUser from '../../files/user.svg';
import Button from '../Button/Button';

const Avatar = ({ name, avatarUrl }) => {
  return (
    <span className="user-avatar__wrapper">
      {avatarUrl ? (
        <img src={avatarUrl} alt={name} className="user-avatar" />
      ) : (
        <IconUser
          title={name}
          className="user-avatar user-avatar--default"
          focusable={false}
        />
      )}
    </span>
  );
};

const UserMenu = ({ loginUrl, memberLinks, user, newsLink }) => {
  if (isEmpty(user)) {
    return (
      <Button href={loginUrl} className="btn btn--login" text="Login">
        <span>Login</span>
      </Button>
    );
  }
  const [isExpanded, setIsExpanded] = useState(false);
  const btnClasses = classnames('btn btn--user', { active: isExpanded });
  const menuClasses = classnames('user-menu margins-off', {
    active: isExpanded,
  });

  const handleKeyDown = (evt) => {
    if (evt.key === 'Escape') {
      setIsExpanded(false);
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    // Remove event listener on cleanup
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []); // Empty array ensures that effect is only run on mount and unmount

  const notificationCount = parseInt(user.notificationCount, 10);

  const countBadge = notificationCount ? (
    <span className="notification-count">{notificationCount}</span>
  ) : null;

  return (
    <Fragment>
      <Button
        className={btnClasses}
        onClick={() => setIsExpanded(!isExpanded)}
        aria-expanded={isExpanded}
        aria-controls="user-menu"
        aria-label="Expand user menu"
      >
        <Avatar {...user} />
        <span className="user-name">{user.name}</span>
        <IconCaret focusable={false} className="icon-caret" />
      </Button>
      <ul id="user-menu" className={menuClasses}>
        {newsLink && (
          <li className="user-menu__item">
            <a href={newsLink} className="user-menu__link">
              News {countBadge}
            </a>
          </li>
        )}
        {memberLinks.map((link, i) => (
          <li key={i} className="user-menu__item">
            <a href={link.url} className="user-menu__link">
              {link.label}
            </a>
          </li>
        ))}
      </ul>
    </Fragment>
  );
};

export default UserMenu;
